<template>
<div>
  <div class="px-4 md:px-14 pt-4 md:pt-8 flex flex-col items-center md:rounded-b-3xl md:shadow-xl">
    <div class="flex gap-8 w-full flex-col md:flex-row ">
      <div class="order-3 md:order-1 z-10 text-lg grow mb-6 relative min-w-[30%] -mt-10 md:mt-0">
        <span class="text-3xl lg:text-5xl xl:text-8xl font-bold mb-8 block">{{ i18n.t('dashboard.title') }}</span>
        <span class="md:text-xl block" v-html="i18n.t('dashboard.main_title')"></span>
      </div>
      <img src="/images/img_marketplace.jpg"  class="order-2  aspect-square w-[calc(100%_+_2rem)] max-w-none md:w-full -ml-4 md:ml-0 md:h-[500px] xl:h-[700px] object-cover object-center md:top-0 relative -top-10 left-0 rounded-3xl" />
    </div>
    <div class="md:px-6 relative md:-mt-48 mb-12">
      <div class="text-lg font-bold mb-4 md:px-8">{{ i18n.t('dashboard.select_destination') }}</div>
      <div class="py-4 mb-10 z-10 relative rounded-full md:px-8">
        <div class="absolute w-full h-full hidden md:block bg-white opacity-90 top-0 left-0 rounded-full"></div>
        <div class="flex flex-col md:flex-row items-center gap-8">
          <div class="rounded-full bg-white md:bg-transparent p-2 px-8 md:p-0 md:px-0">
            <div class="!text-black relative z-10">
              {{ i18n.t('dashboard.country')  }}
            </div>
            <treeselect v-model="country" :options="countries" :clearable="false" class="select-border-less">
              <label slot="option-label" class="p-2" slot-scope="{ node }">
                {{ node.label }}
              </label>
            </treeselect>
          </div>
          <div class="w-0.5 h-[56px] bg-black shrink-0 z-10  hidden md:block"></div>
          <div class="rounded-full bg-white md:bg-transparent p-2 px-8 md:p-0 md:px-0">
            <div class="!text-black relative z-10">
              {{ i18n.t('dashboard.city')  }}
            </div>
            <treeselect v-model="city" :defaultExpandLevel="2" :disabled="!country" :options="cities" :clearable="false" class="select-border-less">
              <label slot="option-label" class="p-2" slot-scope="{ node }">
                {{ node.label }}
              </label>
            </treeselect>
          </div>
          <div class="w-0.5 h-[56px] bg-black shrink-0 z-10 hidden md:block"></div>
          <template v-if="extendedFilters">
            <div class="md:flex-grow shrink-0 z-10 relative w-full  md:w-auto" @click="scrollToView">
              <DatePicker ref="datepicker" v-model="dates" is-range is24hr :minute-increment="60" mode="date" :min-date="new Date()">
                <template #default="{ inputValue, inputEvents }">
                  <div class="flex items-center gap-8 flex-col md:flex-row">
                    <div class="rounded-full bg-white md:bg-transparent p-2 px-8 md:p-0 md:px-0 w-full md:w-auto">
                      <div class="!text-black relative ">
                        {{ i18n.t('general.from')  }}
                      </div>
                      <input class="jt-input !bg-transparent !border-0 pl-0" placeholder="13.09.2024" :value="inputValue.start" v-on="inputEvents.start" />
                    </div>
                    <div class="w-0.5 h-[56px] bg-black shrink-0 z-10  hidden md:block"></div>
                    <div class="rounded-full bg-white md:bg-transparent p-2 px-8 md:p-0 md:px-0  w-full md:w-auto">
                      <div class="!text-black relative">
                        {{ i18n.t('general.to')  }}
                      </div>
                      <input class="jt-input !bg-transparent !border-0 pl-0"  placeholder="16.09.2024"  :value="inputValue.end" v-on="inputEvents.end" />
                    </div>
                  </div>
                </template>
              </DatePicker>
            </div>
            <div class="w-0.5 h-[56px] bg-black shrink-0 z-10  hidden md:block"></div>

          </template>
          <div class="flex items-center gap-4 md:gap-8 w-full md:w-auto shrink-0">
            <div v-if="extendedFilters" class="cursor-pointer text-xs flex items-center gap-1 z-10 shrink-0" @click="extendedFilters = false">
              <button class="jt-btn btn-icon rounded-full shrink-0"><i class="bi bi-filter text-base"></i></button>
              <div class="shrink-0  hidden md:block">{{ i18n.t('dashboard.hide_filters') }}</div>
            </div>
            <div class="cursor-pointer text-xs flex items-center gap-1 z-10 shrink-0" v-else @click="extendedFilters = true">
              <button class="jt-btn btn-icon rounded-full shrink-0"><i class="bi bi-filter text-base"></i></button>
              <div class="shrink-0  hidden md:block">{{ i18n.t('dashboard.more_filters') }}</div>
            </div>
            <div class="flex justify-center shrink-0 grow">
              <button ref="show" class="jt-btn w-full md:max-w-[260px] max-w-none grow rounded-full" @click="search" :disabled="!city">
                <i class="fas fa-search"></i>
                {{ i18n.t('dashboard.show_results') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="px-4 md:px-14 pt-4 md:pt-8 flex flex-col items-center md:rounded-b-3xl md:shadow-xl">
    <div class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-8">
      <div class="cursor-pointer aspect-square w-full relative rounded-lg" @click="setDestination('Spain', 'Fuerteventura')">
        <img src="/images/fuerteventura.jpg" class="object-cover h-full w-full rounded-lg" />
        <div class="text-xl font-bold mt-4 absolute text-white bottom-4 left-4">
          Fuerteventura,<br>
          Canary Islands, Spain
        </div>
      </div>
      <div class="cursor-pointer aspect-square w-full relative rounded-lg" @click="setDestination('Spain', 'Tenerife')">
        <img src="/images/tenerife.jpg" class="object-cover h-full w-full rounded-lg" />
        <div class="text-xl font-bold mt-4 absolute text-white bottom-4 left-4">
          Tenerife,<br>
          Canary Islands, Spain
        </div>
      </div>
      <div class="cursor-pointer aspect-square w-full relative rounded-lg" @click="setDestination('Spain', 'Lanzarote')">
        <img src="/images/lanzarote.png" class="object-cover h-full w-full rounded-lg" />
        <div class="text-xl font-bold mt-4 absolute text-white bottom-4 left-4">
          Lanzarote,<br>
          Canary Islands, Spain
        </div>
      </div>
      <div class="cursor-pointer aspect-square w-full relative rounded-lg" @click="setDestination('Spain', 'Mallorca')">
        <img src="/images/mallorca.png" class="object-cover h-full w-full rounded-lg" />
        <div class="text-xl font-bold mt-4 absolute text-white bottom-4 left-4">
          Mallorca,<br>
          Balearic Islands, Spain
        </div>
      </div>
      <div class="cursor-pointer aspect-square w-full relative rounded-lg" @click="setDestination('Portugal', 'Madeira')">
        <img src="/images/madeira.jpg" class="object-cover h-full w-full rounded-lg" />
        <div class="text-xl font-bold mt-4 absolute text-white bottom-4 left-4">
          Madeira,<br>
          Portugal
        </div>
      </div>
      <div class="cursor-pointer aspect-square w-full relative rounded-lg" @click="setDestination('Italy', 'Sardinia')">
        <img src="/images/sardinia.jpg" class="object-cover h-full w-full rounded-lg" />
        <div class="text-xl font-bold mt-4 absolute text-white bottom-4 left-4">
          Sardinia,<br>
          Italy
        </div>
      </div>
    </div>
  </div>
  <div class="px-4 md:px-14 pt-4 md:pt-8 flex flex-col items-center md:rounded-b-3xl md:shadow-xl">

    <div class="bg-jt-light-grey py-4 w-full relative">
      <div class="text-2xl font-bold mb-4">
        {{ i18n.t('dashboard.you_may_like') }}
      </div>
    </div>

    <div class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-8">
      <Item v-for="item in items" :key="item.id" :item="item" />
    </div>

    <div class="bg-jt-light-grey py-4 w-full relative">
      <div class="text-2xl font-bold mb-4">
        {{ i18n.t('dashboard.you_may_like_lesson') }}
      </div>
    </div>

    <div class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-8">
      <Item v-for="item in items_lesson" :key="item.id" :item="item" />
    </div>
  </div>

  <div class="px-4 md:px-14 pt-4 md:pt-8 flex flex-col items-center">
    <div class="bg-jt-light-grey py-4 w-full relative">
      <div class="text-2xl font-bold mb-4">
        {{ i18n.t('dashboard.how_it_works') }}
      </div>
    </div>
    <div class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-8">
      <div class="bg-white border p-4 rounded">
        <div class="bg-black h-10 w-10 rounded-full flex items-center justify-center mb-2">
          <i class="fas fa-search text-xl text-white"></i>
        </div>
        <div class="font-bold text-xl mb-1">
          {{ i18n.t('dashboard.help_title_1') }}
        </div>
        <div>
          {{ i18n.t('dashboard.help_description_1') }}
        </div>
      </div>
      <div class="bg-white border p-4 rounded">
        <div class="bg-black h-10 w-10 rounded-full flex items-center justify-center mb-2">
          <i class="fas fa-calendar-alt text-xl text-white"></i>
        </div>
        <div class="font-bold text-xl mb-1">
          {{ i18n.t('dashboard.help_title_2') }}
        </div>
        <div>
          {{ i18n.t('dashboard.help_description_2') }}
        </div>
      </div>
      <div class="bg-white border p-4 rounded">
        <div class="bg-black h-10 w-10 rounded-full flex items-center justify-center mb-2">
          <i class="fas fa-map-marked-alt text-xl text-white"></i>
        </div>
        <div class="font-bold text-xl mb-1">
          {{ i18n.t('dashboard.help_title_3') }}
        </div>
        <div>
          {{ i18n.t('dashboard.help_description_3') }}
        </div>
      </div>
      <div class="bg-white border p-4 rounded">
        <div class="bg-black h-10 w-10 rounded-full flex items-center justify-center mb-2">
          <i class="fas fa-route text-xl text-white"></i>
        </div>
        <div class="font-bold text-xl mb-1">
          {{ i18n.t('dashboard.help_title_4') }}
        </div>
        <div>
          {{ i18n.t('dashboard.help_description_4') }}
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import axios from '../../shared/custom_axios.js';
  import Treeselect from '@riophae/vue-treeselect';
  import DatePicker from 'v-calendar/lib/components/date-picker.umd';
  import Item from './item.vue';

  export default {
    name: 'FilterScreen',
    props: {
      itemsUrl: String,
      countriesUrl: String,
      regionsUrl: String,
      subCategoriesUrl: String,
      selectedCountry: String,
      selectedCity: String,
      selectedDates: Object,
      selectedCategory: String | Number,
      selectedSubCategory: String | Number,
      categories: Array,
    },
    components: {
      Treeselect,
      DatePicker,
      Item
    },
    watch: {
      country() {
        this.fetchRegions()
        this.city = null
      },
      category() {
        this.fetchSubCategories()
        this.subCategory = null
      }
    },
    mounted() {
      this.fetchCountries();
    },
    data: function() {
      return {
        items: [],
        items_lesson: [],
        countries: [],
        cities: [],
        subCategories: [],
        country: this.selectedCountry,
        city: this.selectedCity,
        dates: this.selectedDates,
        category: this.selectedCategory,
        subCategory: this.selectedSubCategory,
        extendedFilters: false
      }
    },
    computed: {
      formattedCategories() {
        return this.categories.map(category => {
          return {
            id: category.id,
            label: category.name,
          }
        })
      },
      formattedSubCategories() {
        return this.subCategories.map(subCategory => {
          return {
            id: subCategory.id,
            label: subCategory.name,
          }
        })
      },
    },
    created() {
      if (this.selectedCountry) this.fetchRegions();
      if (this.selectedCategory) this.fetchSubCategories();
      this.getItems();
      this.getItemsLesson();
    },
    methods: {
      setDestination(country, city) {
        this.country = country;
        this.city = city;
        this.search();
      },
      fetchCountries() {
        axios.get(this.countriesUrl)
          .then(response => {
            this.countries = response.data
          })
      },
      fetchRegions() {
        if (!this.country) return;

        axios.get(this.regionsUrl, {
          params: {
            country: this.country
          }
        })
          .then(response => {
            this.cities = response.data
          })
      },
      fetchSubCategories() {
        if (!this.category) return;

        axios.get(this.subCategoriesUrl, {
          params: {
            category_id: this.category
          }
        })
          .then(response => {
            this.subCategories = response.data
          })
      },
      search() {
        let start_date = this.dates ? this.dates.start : null
        let start_date_begin_of_day = start_date ? new Date(start_date.setHours(0, 0, 0, 0)) : null
        let end_date = this.dates ? this.dates.end : null
        let end_date_end_of_day = end_date ? new Date(end_date.setHours(23, 59, 59, 999)) : null

        this.$emit('search', {
          country: this.country,
          city: this.city,
          dates: {
            start: start_date_begin_of_day,
            end: end_date_end_of_day
          },
          category: this.category,
          sub_category: this.subCategory
        })
        window.scrollTo(0, 0);
      },
      getItems() {
        axios.get(this.itemsUrl, { params: { per_page: 4, promo: true } })
          .then(response => {
            this.items = response.data.data
          })
      },
      getItemsLesson() {
        axios.get(this.itemsUrl, { params: { per_page: 4, lessons: true } })
          .then(response => {
            this.items_lesson = response.data.data
          })
      },
      scrollToView() {
        this.$nextTick(() => {
          this.$refs.show.scrollIntoView({ behavior: 'smooth', block: "center", inline: "nearest" })
        })
      }
    }
  }
</script>